module.exports = __webpack_public_path__ + "img/intro_logo.e1b7e453.png";